import React from 'react';
import { Image, Shimmer } from 'react-shimmer'

export default class SearchAnnouncementListItem extends React.Component {
  render() {
    return (
      <a className="search-results__item" href={this.props.announcement.url}>
        <Image
          src={this.props.announcement.image_url}
          fallback={<Shimmer width={56} height={40} />}
          errorFallback={() => (
            <Shimmer width={56} height={40} />
          )}
          NativeImgProps={{ className: 'search-results__thumbnail', alt: this.props.announcement.title }}
        />
        <div className="search-results__item-content">
          <div className="search-results__item-title">{this.props.announcement.title}</div>
          <div className="search-results__item-subtitle">{this.props.announcement.content}</div>
        </div>
      </a>
    );
  }
}
